import { useAppSelector } from "app/hooks";
import { selectToken } from "features/auth/AuthSlice";
import {
  useGetCommentListLoginQuery,
  useGetCommentListPublicQuery,
  useGetQAListLoginQuery,
  useGetQAListPublicQuery,
  useGetReviewListLoginQuery,
  useGetReviewListPublicQuery,
} from "features/comment/service/comment.service";
import {
  CommentCollectionJson,
  TypeList,
} from "features/comment/types/comment.type";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { EndPoint } from "common/types/Api";
type Props = {
  filters: any;
  typeList: TypeList;
  skipload?: boolean;
};
export type Data = {
  data: CommentCollectionJson | undefined;
  isLoading: boolean;
  currentData: CommentCollectionJson | undefined;
  error: FetchBaseQueryError | SerializedError | undefined;
  refetch: () => void;
};
const useGetCommentListEndpoint = ({
  filters,
  typeList,
  skipload = false,
}: Props): EndPoint => {
  // const token = useAppSelector(selectToken);
  // const [token, setToken] = useState<string | null>(null);

  ///////////// Api public
  const token = localStorage.getItem("MAIN:token");
  //
  const { data, isLoading, currentData, error, refetch } =
    useGetCommentListPublicQuery(filters, {
      skip: token !== null || typeList !== "comment" || skipload === true,
    });
  //
  const {
    data: dataListQAPublic,
    isLoading: isLoadingListQAPublic,
    currentData: currentDataListQAPublic,
    error: errorListQAPublic,
    refetch: refetchListQAPublic,
  } = useGetQAListPublicQuery(filters, {
    skip: token !== null || typeList !== "qa",
  });
  //
  const {
    data: dataListReviewPublic,
    isLoading: isLoadingListReviewPublic,
    currentData: currentDataListReviewPublic,
    error: errorListReviewPublic,
    refetch: refetchListReviewPublic,
  } = useGetReviewListPublicQuery(filters, {
    skip: token !== null || typeList !== "review",
  });
  ///////////////////////////////////

  ///////////// Api login
  const {
    data: dataListLogin,
    isLoading: isLoadingListLogin,
    currentData: currentDataListLogin,
    error: errorListLogin,
    refetch: refetchListLogin,
  } = useGetCommentListLoginQuery(filters, {
    skip: skipload === true ? true : token === null || typeList !== "comment",
  });
  //
  const {
    data: dataListReviewLogin,
    isLoading: isLoadingListReviewLogin,
    currentData: currentDataListReviewLogin,
    error: errorListReviewLogin,
    refetch: refetchListReviewLogin,
  } = useGetReviewListLoginQuery(filters, {
    skip: token === null || typeList !== "review",
  });
  //
  const {
    data: dataListQALogin,
    isLoading: isLoadingListQALogin,
    currentData: currentDataListQALogin,
    error: errorListQALogin,
    refetch: refetchListQALogin,
  } = useGetQAListLoginQuery(filters, {
    skip: token === null || typeList !== "qa",
  });

  ////////////////////////////////////
  if (token) {
    if (typeList === "comment") {
      return {
        listData: {
          data: dataListLogin,
          isLoading: isLoadingListLogin,
          currentData: currentDataListLogin,
          error: errorListLogin,
          refetch: refetchListLogin,
        },
      };
    } else if (typeList === "review") {
      return {
        listData: {
          data: dataListReviewLogin,
          isLoading: isLoadingListReviewLogin,
          currentData: currentDataListReviewLogin,
          error: errorListReviewLogin,
          refetch: refetchListReviewLogin,
        },
      };
    } else {
      return {
        listData: {
          data: dataListQALogin,
          isLoading: isLoadingListQALogin,
          currentData: currentDataListQALogin,
          error: errorListQALogin,
          refetch: refetchListQALogin,
        },
      };
    }
    // return {
    //   comment: {
    //     data: dataListLogin,
    //     isLoading: isLoadingListLogin,
    //     currentData: currentDataListLogin,
    //     error: errorListLogin,
    //     refetch: refetchListLogin,
    //   },
    //   review: {
    //     data: dataListReviewLogin,
    //     isLoading: isLoadingListReviewLogin,
    //     currentData: currentDataListReviewLogin,
    //     error: errorListReviewLogin,
    //     refetch: refetchListReviewLogin,
    //   },
    //   qa: {
    //     data: dataListQALogin,
    //     isLoading: isLoadingListQALogin,
    //     currentData: currentDataListQALogin,
    //     error: errorListQALogin,
    //     refetch: refetchListQALogin,
    //   },
    // };
  } else {
    if (typeList === "comment") {
      return {
        listData: {
          data,
          isLoading,
          currentData,
          error,
          refetch,
        },
      };
    } else if (typeList === "review") {
      return {
        listData: {
          data: dataListReviewPublic,
          isLoading: isLoadingListReviewPublic,
          currentData: currentDataListReviewPublic,
          error: errorListReviewPublic,
          refetch: refetchListReviewPublic,
        },
      };
    } else {
      return {
        listData: {
          data: dataListQAPublic,
          isLoading: isLoadingListQAPublic,
          currentData: currentDataListQAPublic,
          error: errorListQAPublic,
          refetch: refetchListQAPublic,
        },
      };
    }
    // return {
    //   comment: {
    //     data,
    //     isLoading,
    //     currentData,
    //     error,
    //     refetch,
    //   },
    //   review: {
    //     data: dataListReviewLogin,
    //     isLoading: isLoadingListReviewLogin,
    //     currentData: currentDataListReviewLogin,
    //     error: errorListReviewLogin,
    //     refetch: refetchListReviewLogin,
    //   },
    //   qa: {
    //     data: dataListQALogin,
    //     isLoading: isLoadingListQALogin,
    //     currentData: currentDataListQALogin,
    //     error: errorListQALogin,
    //     refetch: refetchListQALogin,
    //   },
    // };
  }
};
export default useGetCommentListEndpoint;
